




















import { listFactory } from '@/main/pages';

import { showAlert } from '@/main/utils/notifications';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields,getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { NAME,ALL } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';
import { getColumnsNames } from '@/main/utils/table';

export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
			parameters: 'null' as string,
			fromDate: 'DateFrom',
			toDate: 'DateTo',
		};
	},
	methods: {
		dateValidation() {
			if (this.DateFrom && this.DateTo) {
				const fromDate = new Date(this.DateFrom);
				const toDate = new Date(this.DateTo);
				const Startdate = fromDate.getDate();
				const endtdate = toDate.getDate();
				const startMonth = fromDate.getMonth();
				const endMonth = toDate.getMonth();
				const startYear = fromDate.getFullYear();
				const endYear = toDate.getFullYear();
				if (startMonth !== endMonth || startYear !== endYear) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_DATETOFROM_MONTH_VALIDATION') });
					this.DateFrom = null;
					this.DateTo = null;
					return false;
				} if (Startdate > endtdate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.DateTo = null;
					return false;
				}
				return true;
			}
			return false;
		},
		GetParameters(WorkshopIds: any, fromDate: any, toDate: any, Brands: any) {

			const fDate = new Date(fromDate).toISOString();
			const tDate = new Date(toDate).toISOString();

			this.parameters = `dateFrom=${fDate}&dateTo=${tDate}`;

			if (WorkshopIds.length > 0) {
				WorkshopIds.forEach((WorkshopIds: any) => {
					this.parameters = `${this.parameters}&workshopIds=${WorkshopIds}`;
				});
			}

			if (Brands.length > 0) {
				Brands.forEach((o: any) => {
					this.parameters = `${this.parameters}&BrandIds=${o}`;
				});
			}			
			return this.parameters;
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					DateFrom: this.DateFrom,
					DateTo: this.DateTo,
					ColumnSequence: getColumnsNames(this.table.columns.filter(x => x.isVisible === true)).join(','),
					BrandIds: this.BrandIds,
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		async exportFun() {
			try {
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				if (!this.filter.DateFrom || !this.filter.DateTo) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
					return;
				}
				const getColumnsSequence = getColumnsNames(this.table.columns.filter(x => x.isVisible === true));
				this.startLoading();
				const urlParameters: string = this.GetParameters(this.WorkshopIds, this.DateFrom, this.DateTo, this.BrandIds);
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
				await apiProvider.GetDailyPerformanceReport(urlParameters,getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId), getColumnsSequence);
				}
			}
			catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
	},
	computed: {
		isExportButtonVisible() {
			return this.table.rows.length > 0;
		},
		isExportDisabled() {
			return !(this.DateFrom && this.DateTo);
		},
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	mounted() {
		const element = document.getElementsByClassName('el-main');
		if (element.length !== 0) {
			element[0].classList.remove('d-flex');
		}
	},
});
